/**
 * Created by CoolGuy on 2017/7/9.
 */
import React from 'react';
import {connect} from 'react-redux';
import actions from '../../actions';
import {isWeb} from '../../util/index';
import {  Layout, Icon } from 'antd';
const { Header, Content ,Footer} = Layout;
class RightDetail extends React.Component{
    close = ()=>{
        const {dispatch, selfControl} = this.props;

        if(this.props.beforeClose) {
          this.props.beforeClose();
        }

        if(selfControl){
            this.props.onClose && this.props.onClose();
        }else {
            dispatch(actions.showCommonDetail(false));
        }
    };

    // 如果传入了selfControl表示不需要使用redux的showCommonDetail来控制当前的显示隐藏
    shouldShow = () => {
        const {showCommonDetail, selfControl, show} = this.props;
            return selfControl ? !!show : !!showCommonDetail;
    }

    render(){

        let {header,footer,children} = this.props;
        return (
            this.shouldShow() ?
                <div className="right-detail" onClick={this.close} style={this.props.style}>
                    <div className="content" onClick={(e)=>{e.stopPropagation();}} style={this.props.contentStyle}>
                        <Layout>
                            {header && <Header style={{backgroundColor:"#ffffff",borderBottom:"1px solid #ccc"}}>
                                {header}
                            </Header>}
                            <Layout style={{background:"#ffffff"}}>
                                <Content style={{height:document.documentElement.clientHeight-64,overflowY:"auto"}}>
                                    {children}
                                </Content>
                            </Layout>
                            {footer && <Footer style={{position:"fixed",right:10,bottom:10}}>
                                {footer}
                            </Footer>}
                        </Layout>
                    </div>
                    {isWeb() ? null : <div className="mobile-close" onClick={this.close}>
                      <Icon type="close" />
                    </div>}
                </div> : null
        )

    }
}

export default connect((state)=>({
    showCommonDetail:state.ui.showCommonDetail
}))(RightDetail);



// WEBPACK FOOTER //
// ./src/components/Detail/RightDetail.js